module.exports = __webpack_public_path__ + "static/media/antiwrinklelipandcontour.6c4d12ee.png";